// src/services/state.service.ts
import api from './api';

// Get state dropdown by country (public)
export const getStateDropdown = async (countryId: string, stateId: string = "") => {
  const response = await api.post("/state/getAll", {
    CountryID: countryId,
    StateID: stateId,
  });
  return response.data.data; // array of { ID, StateName, ... }
};